import storage from 'helpers/storage';

const key = 'x-auth-token';

export type AuthTokenType = {
  value?: string;
  isGuest?: boolean;
};

export const getToken = (): AuthTokenType => {
  const token = storage.get(key);

  try {
    return JSON.parse(token) || {};
  } catch (error) {
    console.error(error);
    setToken(null, false);
  }
};

export const setToken = (value: string, isGuest = true) => {
  const token = JSON.stringify({ value, isGuest });
  storage.set(key, token);
};

export const clearToken = () => {
  setToken(null, null);
};
